import { createApp } from 'vue';
import RecentRatingList from '../../components/ratings/recent-rating-list.vue';

document.addEventListener('DOMContentLoaded', () => {
	let templates = document.querySelectorAll("[data-vue='recent-rating-list']");
	for (let el of templates) {
		const initialData = JSON.parse(el.getAttribute('data'));
		const app = createApp(RecentRatingList, { userIdentifiedChar: initialData['userIdentifiedChar'] });
		app.mount(el);
	}
});
